export default "__VITE_ASSET__BvExFfpl__"